<div class="card-body">
    <ul class="list-group list-group-flush">

        <!-- Academic Fee -->
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalAcademicFeeAmountExclVat') | translate }}</span>
            <strong>{{ currentDto['totalAcademicFeeAmount' + suffix + 'ExclVat'] }} €</strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalAcademicFeeAmountVat') | translate }}</span>
            <strong>{{ currentDto['totalAcademicFeeAmount' + suffix + 'Vat'] }} €</strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalAcademicFeeAmountInclVat') | translate }}</span>
            <strong>{{ currentDto['totalAcademicFeeAmount' + suffix + 'InclVat'] }} €</strong>
        </li>

        <!-- Learning Resources -->
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalLearningResourcesFeeAmountExclVat') | translate }}</span>
            <strong>{{ currentDto['totalLearningResourcesFeeAmount' + suffix + 'ExclVat'] }} €</strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalLearningResourcesFeeAmountVat') | translate }}</span>
            <strong>{{ currentDto['totalLearningResourcesFeeAmount' + suffix + 'Vat'] }} €</strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalLearningResourcesFeeAmountInclVat') | translate }}</span>
            <strong>{{ currentDto['totalLearningResourcesFeeAmount' + suffix + 'InclVat'] }} €</strong>
        </li>

        <!-- Academic + Learning Resource -->
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalAcademicWithLearningResourceAmountExclVat') | translate }}</span>
            <strong>{{ currentDto['totalAcademicWithLearningResourceAmount' + suffix + 'ExclVat'] }} €</strong>
        </li>
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalAcademicWithLearningResourceAmountInclVat') | translate }}</span>
            <strong>{{ currentDto['totalAcademicWithLearningResourceAmount' + suffix + 'InclVat'] }} €</strong>
        </li>

        <!-- Shipping -->
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalShippingFeeAmountExclVat') | translate }}</span>
            <strong>{{ currentDto['totalShippingFeeAmount' + suffix + 'ExclVat'] }} €</strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalShippingFeeAmountVat') | translate }}</span>
            <strong>{{ currentDto['totalShippingFeeAmount' + suffix + 'Vat'] }} €</strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalShippingFeeAmountInclVat') | translate }}</span>
            <strong>{{ currentDto['totalShippingFeeAmount' + suffix + 'InclVat'] }} €</strong>
        </li>

        <!-- Optional Administrative -->
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalOptionalAdministrativeFeeAmountExclVat') | translate }}</span>
            <strong>{{ currentDto['totalOptionalAdministrativeFeeAmount' + suffix + 'ExclVat'] }} €</strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalOptionalAdministrativeFeeAmountVat') | translate }}</span>
            <strong>{{ currentDto['totalOptionalAdministrativeFeeAmount' + suffix + 'Vat'] }} €</strong>
        </li>
        
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalOptionalAdministrativeFeeAmountInclVat') | translate }}</span>
            <strong>{{ currentDto['totalOptionalAdministrativeFeeAmount' + suffix + 'InclVat'] }} €</strong>
        </li>
        

        <!-- Mandatory Administrative -->
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalMandatoryAdministrativeFeeAmountExclVat') | translate }}</span>
            <strong>{{ currentDto['totalMandatoryAdministrativeFeeAmount' + suffix + 'ExclVat'] }} €</strong>
        </li>

        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalMandatoryAdministrativeFeeAmountVat') | translate }}</span>
            <strong>{{ currentDto['totalMandatoryAdministrativeFeeAmount' + suffix + 'Vat'] }} €</strong>
        </li>
        
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalMandatoryAdministrativeFeeAmountInclVat') | translate }}</span>
            <strong>{{ currentDto['totalMandatoryAdministrativeFeeAmount' + suffix + 'InclVat'] }} €</strong>
        </li>


        <!-- Discounts -->
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalDiscountAcademicFee') | translate }}</span>
            <strong>{{ currentDto['totalDiscountAcademicFee' + suffix] }} €</strong>
        </li>
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalDiscountLearningResourceFee') | translate }}</span>
            <strong>{{ currentDto['totalDiscountLearningResourceFee' + suffix] }} €</strong>
        </li>
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalShippingDiscountAmount') | translate }}</span>
            <strong>{{ currentDto['totalShippingDiscountAmount' + suffix] }} €</strong>
        </li>
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalOptionalAdministrativeDiscountAmount') | translate }}</span>
            <strong>{{ currentDto['totalOptionalAdministrativeDiscountAmount' + suffix] }} €</strong>
        </li>
        <li class="list-group-item py-2 d-flex justify-content-between">
            <span>{{ ('tuition-calc.totalMandatoryAdministrativeDiscountAmount') | translate }}</span>
            <strong>{{ currentDto['totalMandatoryAdministrativeDiscountAmount' + suffix] }} €</strong>
        </li>

    </ul>
</div>